import Grid from '@mui/material/Grid';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import React from 'react';

interface EmulateAccessPointStepIndicatorProps {
    currentStep: number;
    onReset: () => void;
    translations: Record<string, string>;
}

export const EmulateAccessPointStepIndicator: React.FC<EmulateAccessPointStepIndicatorProps> = ({
    currentStep,
    onReset,
    translations,
}) => (
    <Grid container>
        <Grid item xs={12}>
            <Stepper activeStep={currentStep}>
                <Step onClick={onReset}>
                    <StepLabel>{translations.GLOBAL_ACCESS_POINT_CODE_LABEL}</StepLabel>
                </Step>
                <Step>
                    <StepLabel>{translations.MENU_LINK_SCAN_NFC}</StepLabel>
                </Step>
            </Stepper>
        </Grid>
    </Grid>
);
